import React, { FunctionComponent } from 'react'

import { Spinner } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import { useFormikContext } from 'formikV2'
import { compose } from 'recompose'

import Button from 'components/Button'
import withPartnerProps, { WithPartnerProps } from 'components/HOCs/WithPartnerProps'
import { withClickTrack } from 'components/Trackers/ClickTracker'
import getDefaultEventData from 'components/Trackers/defaults'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import { TestIDs } from 'test/utils/testIds'
import { getButtonTappedEvent } from 'utils/analytics'
import trackEvent from 'utils/analytics/trackEvent'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { PromptProps, withPrompt } from 'utils/prompts'

import { investorQuestionsConfirmation } from './utils'

type EnhancedProps = WithFlowRouterProps & WithPartnerProps & PromptProps

const CreateAccountButton = withClickTrack<any, any>(TRACKER_IDS.INVESTOR_QUESTIONS.SUBMIT_BUTTON)(
  Button,
)

export const enhance = compose<EnhancedProps, {}>(withFlowRouter, withPartnerProps, withPrompt)

export const SubmitButton = ({ flow, partner, promptUser }: EnhancedProps) => {
  const { getRemoteString } = useRemoteStrings()
  const buttonLabel = getRemoteString({ key: 'investor_questions.submit_button' })
  const { isSubmitting, submitForm, values: formValues } = useFormikContext()

  const handleButtonPress = async () => {
    trackEvent('Button Tapped', {
      eventData: {
        ...getButtonTappedEvent(TRACKER_IDS.INVESTOR_QUESTIONS.SUBMIT_BUTTON),
        ...getDefaultEventData('Button Tapped'),
        cta_title: buttonLabel,
      },
      partner,
      flow,
    })

    if (await investorQuestionsConfirmation(promptUser, formValues)) {
      await submitForm()
    }
  }

  return (
    <CreateAccountButton
      onPress={handleButtonPress}
      data-testid={TestIDs.INVESTOR_QUESTIONS.SUBMIT_CTA}
      disabled={isSubmitting}
      buttonType={'submit'}
    >
      {isSubmitting ? <Spinner height={20} width={20} white={true} /> : buttonLabel}
    </CreateAccountButton>
  )
}

export default enhance(SubmitButton as FunctionComponent)
